module.exports = __webpack_public_path__ + "static/media/icon-team-survey-progress-incomplete.3670b466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-team-survey-progress-incomplete.svg
// module id = 1903
// module chunks = 0